import React, { useState, useEffect } from "react";
import { Container } from "@mui/material";
import UserBox from "./users/UserBox";
import MessageMain from "./messages/MessageMain";
import { ChatWrapper } from "./styles/ChatBoxMainStyles";
import Nochat from "./Nochat";
import { useSelector } from "react-redux";

const ChatBoxMain = ({ AllData = [] }) => {
  const SelectedUserValue = useSelector(
    (state) => state.adminchat.SearchSelectedUser
  );
  console.log(
    "🚀 ~ file: ChatBoxMain.js:11 ~ ChatBoxMain ~ SelectedUserValue:",
    SelectedUserValue
  );
  const [activeIndex, setActiveIndex] = useState("");
  const [UserObj, setUserObj] = useState({});

  useEffect(() => {
    if (SelectedUserValue) {
      setUserObj(SelectedUserValue);
    }
  }, [SelectedUserValue]);

  return (
    <>
      <Container maxWidth="lg">
        <ChatWrapper className="ChatWrapper">
          <UserBox
            AllData={AllData}
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
            setUserObj={setUserObj}
          />

          {!UserObj?.user_slug && <Nochat />}
          {UserObj?.user_slug && <MessageMain UserObj={UserObj} />}
        </ChatWrapper>
      </Container>
    </>
  );
};

export default ChatBoxMain;
